import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CourseRegisterationForm.css";

export default function CourseRegistrationForm() {
  const navigate = useNavigate(); // <-- hook for navigation

  const [form, setForm] = useState({
    uid: "",
    fname: "",
    email: "",
    cNumber: "",
    amppUser: "",
    amppUsername: "",
    amppMember: "",
    amppMemberID: "",
    trainingEvent: "",
    attendTime: "",
    costBearer: "",
    paymentCurrency: "",
    preferredLocation: "",
  });

  const [errors, setErrors] = useState({});

  // Load user info from localStorage
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setForm((prev) => ({
        ...prev,
        uid: user.uid || "",
        fname: user.fname || "",
        email: user.email || "",
        cNumber: user.cNumber || "",
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    // Reset conditional fields
    if (name === "amppUser" && value !== "Yes") {
      setForm((prev) => ({ ...prev, amppUsername: "" }));
    }
    if (name === "amppMember" && value !== "Yes") {
      setForm((prev) => ({ ...prev, amppMemberID: "" }));
    }
  };

  const validate = () => {
    const tempErrors = {};

    // Required fields except UID (auto)
    if (!form.fname) tempErrors.fname = "Name is required";
    if (!form.email) tempErrors.email = "Email is required";
    if (!form.cNumber) tempErrors.cNumber = "Contact number is required";

    if (!form.amppUser) tempErrors.amppUser = "Please select an option";
    if (form.amppUser === "Yes" && !form.amppUsername.trim())
      tempErrors.amppUsername = "Please enter your AMPP username";

    if (!form.amppMember) tempErrors.amppMember = "Please select an option";
    if (form.amppMember === "Yes" && !form.amppMemberID.trim())
      tempErrors.amppMemberID = "Please enter your AMPP member ID";

    if (!form.trainingEvent)
      tempErrors.trainingEvent = "Please select a training event";
    if (!form.attendTime) tempErrors.attendTime = "Please select a time frame";
    if (!form.costBearer)
      tempErrors.costBearer = "Please select who will bear the cost";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const res = await fetch("https://agepcoatings.com/registercourse", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form), // UID included automatically
      });
      const data = await res.json();
      if (res.ok) {
        alert(data.message); // optional
        navigate("/"); // <-- Navigate to home after success
      } else {
        alert(data.message);
      }
    } catch (err) {
      alert("Error: " + err.message);
    }
  };
  return (
    <div className="course-form-container mb-5">
      <Link to={"/"} className="btn custom-back-btn mb-4">
        ← Back to Home
      </Link>
      <h2 className="form-title">Expression of Interest</h2>
      <form onSubmit={handleSubmit} className="form-grid">
        {/* Auto-filled and editable fields */}
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="fname"
            value={form.fname}
            onChange={handleChange}
          />
          {errors.fname && <span className="error">{errors.fname}</span>}
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
          />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>
        <div className="form-group">
          <label>Contact Number</label>
          <input
            type="tel"
            name="cNumber"
            value={form.cNumber}
            onChange={handleChange}
          />
          {errors.cNumber && <span className="error">{errors.cNumber}</span>}
        </div>

        {/* AMPP User */}
        <div className="form-group">
          <label>Are you an AMPP User?</label>
          <select name="amppUser" value={form.amppUser} onChange={handleChange}>
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.amppUser && <span className="error">{errors.amppUser}</span>}
        </div>
        {form.amppUser === "Yes" && (
          <div className="form-group">
            <label>AMPP Username</label>
            <input
              type="text"
              name="amppUsername"
              value={form.amppUsername}
              onChange={handleChange}
            />
            {errors.amppUsername && (
              <span className="error">{errors.amppUsername}</span>
            )}
          </div>
        )}

        {/* AMPP Member */}
        <div className="form-group">
          <label>Are you an AMPP Member?</label>
          <select
            name="amppMember"
            value={form.amppMember}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors.amppMember && (
            <span className="error">{errors.amppMember}</span>
          )}
        </div>
        {form.amppMember === "Yes" && (
          <div className="form-group">
            <label>AMPP Member ID</label>
            <input
              type="text"
              name="amppMemberID"
              value={form.amppMemberID}
              onChange={handleChange}
            />
            {errors.amppMemberID && (
              <span className="error">{errors.amppMemberID}</span>
            )}
          </div>
        )}

        {/* Training Event */}
        <div className="form-group">
          <label>Training Event</label>
          <select
            name="trainingEvent"
            value={form.trainingEvent}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="BasicCorrosion">Basic Corrosion</option>
            <option value="FusionBondedEpoxy">Fusion Bonded Epoxy</option>
            <option value="CorrosionUnderInsulation">
              Corrosion Under Insulation
            </option>
            <option value="ShipboardCorrosionAssessmentTraining">
              Shipboard Corrosion Assessment
            </option>
            <option value="OffshoreCorrosionAssessmentTraining">
              Offshore Corrosion Assessment
            </option>
            <option value="PipelineCorrosionAssessmentTraining">
              Pipeline Corrosion Assessment
            </option>
            <option value="CertifiedBlasterC7">Certified Blaster C7</option>
            <option value="CertifiedCoatingApplicatorC12">
              Certified Coating Applicator C12
            </option>
          </select>
          {errors.trainingEvent && (
            <span className="error">{errors.trainingEvent}</span>
          )}
        </div>

        {/* Attend Time */}
        <div className="form-group">
          <label>Attend Time</label>
          <select
            name="attendTime"
            value={form.attendTime}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Within3Months">Within 3 months</option>
            <option value="Within3to6Months">Within 3-6 months</option>
            <option value="Undecided">Undecided</option>
          </select>
          {errors.attendTime && (
            <span className="error">{errors.attendTime}</span>
          )}
        </div>

        {/* Cost Bearer */}
        <div className="form-group">
          <label>Cost Bearer</label>
          <select
            name="costBearer"
            value={form.costBearer}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Self">Self-funded</option>
            <option value="Employer">Employer Sponsored</option>
          </select>
          {errors.costBearer && (
            <span className="error">{errors.costBearer}</span>
          )}
        </div>

        {/* Payment Currency */}
        {form.costBearer === "Self" && (
          <div className="form-group">
            <label>Payment Currency</label>
            <select
              name="paymentCurrency"
              value={form.paymentCurrency}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="INR">INR</option>
              <option value="USD">USD</option>
            </select>
          </div>
        )}

        {/* Preferred Location */}
        <div className="form-group">
          <label>Preferred Location</label>
          <select
            name="preferredLocation"
            value={form.preferredLocation}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Mumbai">Mumbai</option>
            <option value="Cochin">Cochin</option>
            <option value="Ahmedabad">Ahmedabad</option>
            <option value="NoPreference">No Preference</option>
          </select>
        </div>

        {/* Submit */}
        <div className="form-group full-width">
          <button type="submit" className="submit-btn">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
